import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormationDocuments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#ffad77",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "FormationDocuments",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 16660",
				d: "M2.5 0.5H10.3789C10.644 0.50006 10.8985 0.605486 11.0859 0.792969L14.207 3.91406C14.3945 4.10155 14.4999 4.35596 14.5 4.62109V14.5C14.5 15.0523 14.0523 15.5 13.5 15.5H2.5C1.94772 15.5 1.5 15.0523 1.5 14.5V1.5C1.5 0.947715 1.94772 0.5 2.5 0.5Z",
				fill: "currentColor",
				fillOpacity: .25,
				stroke: "currentColor"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Calendar",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M4.72269 5.22696H11.2771C11.2771 5.22696 11.7813 5.22696 11.7813 5.73115V11.2772C11.7813 11.2772 11.7813 11.7814 11.2771 11.7814H4.72269C4.72269 11.7814 4.21851 11.7814 4.21851 11.2772V5.73115C4.21851 5.73115 4.21851 5.22696 4.72269 5.22696Z",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M4.21851 7.24371H11.7813",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M6.23535 5.22699V4.21863",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M9.76465 5.22699V4.21863",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			})]
		})
	})
});
export default SvgFormationDocuments;
